<canvas id="skillsBarChart"></canvas>
